import { useEffect, useState } from "react";
import ContentHeader from "../../../layout/ContenteHeader";
import Content from "../../../layout/Content";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import crudApi from "@serie3/common/api/crudApi";
import ProfileForm from "@serie3/freelancesplaceapi/Form/Profile/ProfileForm";
import TabContent from "../../../layout/Tabs/TabContent";
import TabHeader from "../../../layout/Tabs/TabHeader";
import {
  faMoneyBill,
  faUser,
  faGraduationCap,
  faBookOpenReader,
  faHandshake,
  faCog,
  faContactCard,
  faIdCard,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TabLink from "../../../layout/Tabs/TabLink";
import TabBody from "../../../layout/Tabs/TabBody";
import ProfileConfig from "@serie3/freelancesplaceapi/Config/Profiles/ProfileConfig";
import ProfileBasics from "./Tabs/ProfileBasics";
import ContactData from "./Tabs/ContactData";
import PricesAndAvailability from "./Tabs/PricesAndAvailability";
import Skills from "./Tabs/Skills";
import ProfileLeft from "./ProfileLeft";
import Education from "./Tabs/Education";
import Workexperience from "./Tabs/WorkExperience";
import ProfileSettings from "./Tabs/ProfileSettings";

const Edit = () => {
  const [editProfile, setEditProfile] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [originalSkillList, setOriginalSkillList] = useState([]);
  const [showError, setShowError] = useState(false);
  const [qualifications, setQualifications] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [searchingFor, setSearchingFor] = useState([]);
  const [updateJobs, setUpdateJobs] = useState([]);
  let { id } = useParams();

  const prefix = "profile";

  const editProfileForm = ProfileForm.createProfileForm(
    setShowError,
    setOriginalSkillList,
    setQualifications,
    setLanguages
  );

  const formik = useFormik(editProfileForm);

  const title = () => <b>Profile</b>;

  useEffect(() => {
    const loadData = async (id) => {
      const profile = await crudApi.show(ProfileConfig.endpoints.show, id);
      setEditProfile(profile);
      setOriginalSkillList(profile.skills);
      setLanguages([...profile.languages]);
      formik.setValues(ProfileForm.setEditData(profile));
      setIsLoaded(true);
    };
    loadData(id);
  }, [id]);

  useEffect(() => {
    setUpdateJobs(!updateJobs);
  }, [originalSkillList, qualifications, languages, searchingFor]);

  const SaveButton = () => (
    <button
      type="button"
      onClick={(e) => { formik.handleSubmit(e); e.preventDefault(); }}
      style={{
        display: "inline-flex", alignItems: "center", gap: "6px",
        padding: "8px 18px", background: "#1a73e8", color: "#fff",
        border: "none", borderRadius: "10px", fontWeight: 700,
        fontSize: "0.85rem", cursor: "pointer", transition: "background 0.15s",
        boxShadow: "0 2px 8px rgba(26,115,232,0.3)",
      }}
      onMouseOver={e => e.currentTarget.style.background = "#1557b0"}
      onMouseOut={e => e.currentTarget.style.background = "#1a73e8"}
    >
      <FontAwesomeIcon icon={faFloppyDisk} style={{ fontSize: "0.78rem" }} />
      Save
    </button>
  );

  return isLoaded ? (
    <>
      <ContentHeader>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{
            width: "46px", height: "46px", borderRadius: "12px",
            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
            color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "1.2rem", flexShrink: 0, boxShadow: "0 4px 12px rgba(26,115,232,0.3)",
          }}>
            <FontAwesomeIcon icon={faIdCard} />
          </div>
          <div>
            <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#212121", lineHeight: 1.2 }}>
              Profile
            </div>
            <div style={{ fontSize: "0.85rem", color: "#9e9e9e", marginTop: "2px" }}>
              Manage your freelancer profile
            </div>
          </div>
        </div>
      </ContentHeader>

      <Content Title={title}>
        <Row>
          <ProfileLeft formik={formik} profile={editProfile} updateJobs={updateJobs} />
          <Col className="col-md-9">
            <div style={{
              background: "#fff", borderRadius: "16px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.08)", overflow: "hidden",
            }}>
              <TabHeader prefix={prefix}>
                <TabLink prefix={prefix} name={"Basics"} icon={faUser} />
                <TabLink prefix={prefix} name={"Contacts"} icon={faContactCard} />
                <TabLink prefix={prefix} name={"Prices"} icon={faMoneyBill} />
                <TabLink prefix={prefix} name={"Skills"} icon={faBookOpenReader} />
                <TabLink prefix={prefix} name={"Education"} icon={faGraduationCap} />
                <TabLink prefix={prefix} name={"Workhistory"} icon={faHandshake} />
                <TabLink prefix={prefix} name={"Settings"} icon={faCog} />
              </TabHeader>

              <TabBody>
                <TabContent prefix={prefix} name={"Basics"} show={true}>
                  <ProfileBasics
                    formik={formik}
                    SaveButton={SaveButton}
                    profile={editProfile}
                    searchingFor={searchingFor}
                    setSearchingFor={setSearchingFor}
                    languages={languages}
                    setLanguages={setLanguages}
                  />
                </TabContent>
                <TabContent prefix={prefix} name={"Contacts"}>
                  <ContactData formik={formik} profile={editProfile} SaveButton={SaveButton} />
                </TabContent>
                <TabContent prefix={prefix} name={"Prices"}>
                  <PricesAndAvailability formik={formik} SaveButton={SaveButton} />
                </TabContent>
                <TabContent prefix={prefix} name={"Skills"}>
                  <Skills
                    formik={formik}
                    profile={editProfile}
                    SaveButton={SaveButton}
                    originalSkillList={originalSkillList}
                    setOriginalSkillList={setOriginalSkillList}
                    qualifications={qualifications}
                    setQualifications={setQualifications}
                  />
                </TabContent>
                <TabContent prefix={prefix} name={"Education"}>
                  <Education formik={formik} profile={editProfile} />
                </TabContent>
                <TabContent prefix={prefix} name={"Workhistory"}>
                  <Workexperience formik={formik} profile={editProfile} />
                </TabContent>
                <TabContent prefix={prefix} name={"Settings"}>
                  <ProfileSettings formik={formik} />
                </TabContent>
              </TabBody>
            </div>
          </Col>
        </Row>
      </Content>
    </>
  ) : null;
};

export default Edit;
